import React from "react";
import { Recycle } from "lucide-react";
import CrudModule from "@/components/CrudModule";

export default function Waste() {
  return (
    <CrudModule
      title="Gestão de Resíduos (ISO 14001)"
      subtitle="Registro de geração e destinação de resíduos industriais — MTR / CDF"
      icon={Recycle}
      endpoint="waste-records"
      exportKey="waste-records"
      testid="waste"
      columns={[
        { key: "date", label: "Data" },
        { key: "waste_type", label: "Classe" },
        { key: "description", label: "Descrição" },
        { key: "weight_kg", label: "Peso (kg)" },
        { key: "destination_company", label: "Destinação" },
        { key: "mtr_number", label: "MTR" },
        { key: "cert", label: "CDF/MTR", file: true, idKey: "certificate_id" },
      ]}
      fields={[
        { name: "date", label: "Data de geração", type: "date", required: true },
        { name: "waste_type", label: "Classificação", type: "select", options: ["Classe I - Perigoso", "Classe II A - Não Inerte", "Classe II B - Inerte"], default: "Classe I - Perigoso" },
        { name: "description", label: "Descrição (ex: óleo usado, sucata, panos contaminados)", type: "text", required: true, full: true },
        { name: "weight_kg", label: "Peso (kg)", type: "number" },
        { name: "destination_company", label: "Empresa de destinação", type: "text" },
        { name: "mtr_number", label: "Número do MTR", type: "text" },
        { name: "certificate", label: "MTR / CDF (upload)", type: "file", idKey: "certificate_id", nameKey: "certificate_name", full: true },
      ]}
    />
  );
}
